module.exports = __webpack_public_path__ + "img/Toyota.629d80bb.svg";